module.exports = __webpack_public_path__ + "static/media/mainBgTablet.9e73d582.png";